<template>
	<div class="filter-participants">
		<div class="row">
			<div class="cols s_24">
				<div class="wrapper">
					<template v-if='data'>
						<div class="search" v-if='data.search'>
							<input
								v-model='searchString'
								:placeholder='data.search.placeholder'
								@keydown.enter='submitSearch'
							/>

							<span @click='submitSearch'></span>

							<b @click='resetSearch' v-show='searchString.length'></b>
						</div>

						<div class="dropdowns">
							<template v-for='drop in data.dropdowns'>
							<span class="label">{{drop.label}}</span>
								<v-dropdown
									:data='drop'
									:v-html='drop.label'
									@changed='ddChanged'
									@mounted='ddMounted'
								/>
							</template>
						</div>

						<div class="labels">
							<template v-for='label in data.labels'>
								<div :class='`label ${label.type} ${label.active ? "active" : ""}`' :name='label.name' @click='lblClick($event, label.name)'>
									{{label.text}}
									<template v-if='label.count'>({{label.count}})</template>
								</div>
							</template>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const objectMerge = require('object-merge');

module.exports = {
	props: [
		'data'
	],

	components: {
		'v-dropdown': require('../forms/elements/dropdown.vue')
	},

	data() {
		return {
			dropdowns: {},
			labels: {},
			searchString: '',
			search: {},
			watchFlag: true
		}
	},

	methods: {

		ddChanged(payload) {
			this.dropdowns[payload.name] = payload.value;

			this.$emit('FILTER_CHANGE', objectMerge(this.dropdowns, this.labels, this.search));
		},

		ddMounted(payload) {
			// console.log(payload);
			this.dropdowns[payload.name] = payload.value;
		},

		lblClick(e, name) {
			// console.log(e, name);
			if($(e.target).is(':first-child')) {
				// клік по першому елементу який є "всі"

				$(this.$el).find('.labels .label').each((i, el) => {
					$(el).removeClass('active');
					// console.log(el, el.getAttribute('name'));
					delete this.labels[el.getAttribute('name')];
				})
			}
			else {
				$(this.$el).find('.labels .label:first-child').removeClass('active');
				delete this.labels[$(this.$el).find('.labels .label:first-child').attr('name')];
			}

			if(e.target.classList.contains('active')) {
				e.target.classList.remove('active');

				// console.log(this.labels);
				// console.log(this.labels[name]);
				// this.labels[name] = undefined;
				delete this.labels[name];
				// console.log(this.labels);
				// console.log(this.labels[name]);
			}
			else {
				e.target.classList.add('active');

				this.labels[name] = 'Y';
			}


			this.$emit('FILTER_CHANGE', objectMerge(this.dropdowns, this.labels, this.search));
		},

		submitSearch() {
			this.search[this.data.search.name] = this.searchString;
			this.$emit('FILTER_CHANGE', objectMerge(this.dropdowns, this.labels, this.search));
		},

		resetSearch() {
			this.searchString = '';

			this.submitSearch()
		}
	},

	watch: {
		data() {
			// console.log(this.data.dropdowns);
			if(this.data.dropdowns){
				this.data.dropdowns.forEach(drop => {
					if(!this.dropdowns[drop.name]) {
						this.dropdowns[drop.name] = drop.options[0].value;
					}
					// console.log(drop);
				})
			}

			if(this.data.search) {
				// якщо є поле пошуку

				if(!this.search[this.data.search.name]) {
					this.search[this.data.search.name] = '';
				}
			}

			if(this.watchFlag) {
				console.log('do something');
				this.watchFlag = false;

				if(this.data.labels){
					this.data.labels.map(label => {
						if(label.active) {
							console.log(label.name + ' is active');
							this.labels[label.name] = 'Y';
						}
					});
				}
				this.$emit('FILTER_CHANGE_PAYLOAD', objectMerge(this.dropdowns, this.labels, this.search));
			}

			// console.log(this.labels);

			// if(this.data.labels.length && this.watchFlag) {
			// 	this.data.labels.map(label => {
			// 		label.active ? this.labels[label.name] = 'Y' : false;
			// 		// $(`.labels .label[name="${label.name}"]`).click()
			// 		// console.log(this.labels);
			// 	})
			//
			// 	this.watchFlag = false;
			//
			// 	// console.log('emit');
			// 	this.$emit('FILTER_CHANGE_PAYLOAD', objectMerge(this.dropdowns, this.labels, this.search));
			// }
		}
	}
}
</script>

<style lang="scss">
	@import "scss/wanted";

	.filter-participants {

		// .wrapper {
		// 	display: flex;
		// 	align-items: center;
		// 	flex-wrap: wrap;
		// }

		// .search {
		// 	margin: 0 20px 0 0;
		// 	width: 250px;
		// 	position: relative;
      //
		// 	input {
		// 		height: 32px;
		// 		border-radius: 16px;
		// 		border: 1px solid #a0a3a8;
		// 		font-size: 13px;
		// 		padding: 0 55px 0 16px;
		// 	}
      //
		// 	span {
		// 		display: block;
		// 		width: 17px;
		// 		height: 17px;
		// 		background: url('#{$imgPathSCSS}search.png') no-repeat center;
		// 		cursor: pointer;
		// 		position: absolute;
		// 		top: calc(50% - 8px);
		// 		right: 10px;
		// 	}
      //
		// 	b {
		// 		display: block;
		// 		width: 17px;
		// 		height: 17px;
		// 		background: url('#{$imgPathSCSS}close.png') no-repeat center;
		// 		cursor: pointer;
		// 		position: absolute;
		// 		top: calc(50% - 8px);
		// 		right: 30px;
		// 	}
		// }

		.dropdowns {
			display: flex;
			flex-wrap: wrap;
			min-width: 200px;
			@include m_up {
				margin: 0 0 20px;
			};
			@include l_up {
				margin: 0;
			};
			.value{
				height: 49px;
			}
			.mainContainer{
				width: 100%;
			}
			.dropdownWrapper{
				&:after{
					display: none;
				}
			}
		}

		.labels {
			display: flex;
			align-items: center;
			flex-wrap: wrap;

			.label {
				display: inline-flex;
				align-items: center;
				height: 32px;
				font-size: 11px;
				font-weight: 900;
				text-transform: uppercase;
				border: 1px solid #a0a3a8;
				background-repeat: no-repeat;
				background-position: 16px center;
				color: #a0a3a8;
				cursor: pointer;
				@include single-transition;
				margin: 0 10px 10px 0;
				@include l_up {
					margin: 0 10px 0 0;
				};

				&.active {

				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// participants.vue?ff48dd50